import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import WhiteSpaceServices from "../../../../services/WhiteSpace.services";
import { setWhitespacePieValues } from "../../../../store/components/Reports.slice";
import RenderComponent from "../../../General/RenderComponent";
import WhiteSpaceLineChart from "./WhiteSpaceLineChart";
import { createPromise } from "../../../../utils/MainHelper";
import TrackFeatureServices from "../../../../services/TrackFeature.services";

function WhiteSpaceCategoryLine({
    category
}) {
    const dispatch = useDispatch();
    const [isLoadingPie, setIsLoadingPie] = useState(false);
    const [noData, setNoData] = useState(false);
    const [lineData, setLineData] = useState([]);
    const [loadingPercent, setLoadingPercent] = useState(0);

    useEffect(() => {
        setIsLoadingPie(true);
        const { promise, resolve } = createPromise();
        const responses = [];
        const recursiveCall = (idx) => {
            const child = category.children[idx];
            if (!child) return resolve(responses);
            const { commonParams } = TrackFeatureServices.getMonitor({ featureKey: "whitespaceGetCategoryLine" })
            return WhiteSpaceServices.getRelations(child, commonParams).then((result) => {
                responses.push({
                    macro: child,
                    result
                });
                const percent = ((idx + 1) / (category.children.length - 1)) * 100;
                setLoadingPercent(percent);
                dispatch(setWhitespacePieValues({
                    key: child.path,
                    value: {
                        path: child.path,
                        title: child.title,
                        value: result
                    }
                }));
                recursiveCall(idx + 1);
            });
        };
        setLoadingPercent(0);
        recursiveCall(0);

        promise.then((data) => {
            setLineData(data.reduce((acc, item) => {
                const { macro, result } = item;
                result.forEach((line) => {
                    if (!line.isTopic) {
                        acc.push({ name: macro.name, score: line.score, brand: line.title });
                    }
                });

                return acc;
            }, []));
            setIsLoadingPie(false);
        });
    }, [category]);

    useEffect(() => {
        if (!lineData.reduce((acc, d) => {
            acc += d.score;
            return acc;
        }, 0)) {
            setNoData(true);
        } else {
            setNoData(false);
        }
    }, [lineData]);
    return (
        <div
            key={category.name}
            className="d-flex-col whitespace-chartItem"
            name={category.name}
            style={{
                width: "calc(100% - 2mm)",
                height: "145mm",
                border: "1px solid #E2E8F0",
                padding: "2mm",
                marginBottom: "2mm",
                borderRadius: "3px",
                backgroundColor: "white"
            }}
        >
            <div style={{ padding: "4mm" }}>
                <span className="fs-19 fw-700 c-bg-700">
                    <span>{category.name}</span>
                    <span style={{
                        marginLeft: "2mm",
                        fontWeight: "normal"
                    }}
                    >
                        - Share of Consideration
                    </span>
                </span>
            </div>
            <RenderComponent
                isFullscreen
                loadingProps={{
                    loading: isLoadingPie,
                    description: (<div>
                        <div>Loading Chart.</div>
                        <div>{`Please wait...(${(loadingPercent || 5).toFixed(2)}%)`}</div>
                    </div>)
                }}
            >
                <WhiteSpaceLineChart data={lineData} noData={noData} />
            </RenderComponent>
        </div>
    );
}

export default WhiteSpaceCategoryLine;
